import { BidderCount, Lot } from "@/types/types";
import { DARStore } from "@/types/store";
import axios from "axios";
import { restEndpoint } from "@/helpers/endpoints";
import { ActionContext } from "vuex";
import {
  AddOnlineInterestMessage,
  // FairWarningMessage,
  RemoveOnlineInterestMessage
  // ResolveLotMessage
} from "@/types/websocketMessages/outcomeMessages";

export const moduleLots = {
  state: () => ({ lots: [] }),
  mutations: {
    addLot(state: DARStore, lot: Lot) {
      if (lot === null) return;
      // Backwards compat
      if (lot.onlineInterest === null || lot.onlineInterest === undefined) {
        lot.onlineInterest = [];
      }

      const oldLotId = state.lots.findIndex(l => l.number === lot.number);
      if (oldLotId !== -1) {
        state.lots[oldLotId] = lot;
      } else {
        state.lots.push(lot);
        state.lots = state.lots.sort((a, b) => a.position - b.position);
      }
    },
    setCurrentLot(state: DARStore, lot: Lot) {
      state.currentLotId = lot.number;
      state.previousLotId = lot.previousLotId;
      state.nextLotId = lot.nextLotId;
    },
    setNextLot(state: DARStore, lot: Lot) {
      state.currentLotId = undefined;
      state.previousLotId = undefined;
      state.nextLotId = lot.number;
    },
    setPreviousLot(state: DARStore, lot: Lot) {
      state.currentLotId = undefined;
      state.previousLotId = lot.number;
      state.nextLotId = undefined;
    },
    clerkViewLot(state: DARStore, lotId: string) {
      state.clerkViewingLotId = lotId;
    }
  },
  actions: {
    async selectLot(
      { commit, getters }: ActionContext<DARStore, DARStore>,
      lotNumber: string
    ) {
      let newCurrentLot = getters.lot(lotNumber);
      if (!newCurrentLot) {
        const { data } = await axios.get(
          restEndpoint("/dar/lot/" + lotNumber),
          { headers: { "dar-client-token": getters.clientToken } }
        );
        newCurrentLot = data;
      }

      const oldCurrentLot = getters.currentLot;
      if (oldCurrentLot && oldCurrentLot?.status === "offered") {
        oldCurrentLot.status = "waiting";
        commit("addLot", oldCurrentLot);
      }

      commit("addLot", newCurrentLot);
      commit("setCurrentLot", newCurrentLot);
      commit("setIsSaleProvisional", false);

      // Do not load lot ahead if we are online bidder
      // This caused spam of request in big auctions
      if (window.location.pathname.includes("online-bidding")) {
        return;
      }

      if (!getters.previousLot && newCurrentLot.previousLotId) {
        axios
          .get(restEndpoint("/dar/lot/" + newCurrentLot.previousLotId), {
            headers: { "dar-client-token": getters.clientToken }
          })
          .then(({ data }: { data: Lot }) => {
            commit("addLot", data);
          });
      }

      if (!getters.nextLot && newCurrentLot.nextLotId) {
        axios
          .get(restEndpoint("/dar/lot/" + newCurrentLot.nextLotId), {
            headers: { "dar-client-token": getters.clientToken }
          })
          .then(({ data }: { data: Lot }) => {
            commit("addLot", data);
          });
      }
    },
    async clerkViewLot(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      lotId: string
    ) {
      commit("clerkViewLot", lotId);
    },
    async addOnlineInterest(
      { commit, getters }: ActionContext<DARStore, DARStore>,
      { bidder, lotNumber }: AddOnlineInterestMessage
    ) {
      let lot: Lot = getters.lot(lotNumber);
      if (!lot) {
        lot = await axios.get(restEndpoint("/dar/lot/" + lotNumber), {
          headers: { "dar-client-token": getters.clientToken }
        });
      }
      const index = lot.onlineInterest.findIndex(
        b => b.paddleNumber === bidder.paddleNumber
      );
      if (index < 0) {
        lot.onlineInterest.push(bidder);
      }
      commit("addLot", lot);
    },
    async removeOnlineInterest(
      { commit, getters }: ActionContext<DARStore, DARStore>,
      { bidder, lotNumber }: RemoveOnlineInterestMessage
    ) {
      let lot: Lot = getters.lot(lotNumber);
      if (!lot) {
        lot = await axios.get(restEndpoint("/dar/lot/" + lotNumber), {
          headers: { "dar-client-token": getters.clientToken }
        });
      }
      const index = lot.onlineInterest.findIndex(
        b => b.paddleNumber === bidder.paddleNumber
      );
      if (index >= 0) {
        lot.onlineInterest.splice(index, 1);
      }
      commit("addLot", lot);
    },
    async clerkSelectLot(
      { commit, getters }: ActionContext<DARStore, DARStore>,
      { bidder, lotNumber }: RemoveOnlineInterestMessage
    ) {
      // commit("addLot", lot);
    },
    async clerkPlaceBid(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { value, lotNumber }: { value: number; lotNumber: string }
    ) {
      console.log("clerk added bid", value, lotNumber);
      // commit("addLot", lot);
      // dispatch("")
    },
    async clerkResolveSoldLot(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { lotNumber }: { lotNumber: string }
    ) {
      console.log("clerk Resolved sold Lot", lotNumber);
    },
    async clerkSellLot(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { paddle, lotNumber }: { paddle: string; lotNumber: string }
    ) {
      console.log("clerk sell lot", paddle, lotNumber);
    },
    async clerkPassLot(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { lotNumber }: { lotNumber: string }
    ) {
      console.log("clerk pass lot", lotNumber);
    },
    async clerkSetAskingPrice(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { lotNumber, value }: { lotNumber: string; value: number }
    ) {
      console.log("clerk set asking price", lotNumber, value);
    },
    async clerkUndoBid(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { bidId }: { bidId: string }
    ) {
      console.log("clerk undo bid", bidId);
    },
    // TEMPORARY FOR CONVENIENCE

    async manuallyAddOnlineInterest(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { lotNumber }: { lotNumber: string }
    ) {
      console.log("add online interest", lotNumber);
    },
    async manuallyRemoveOnlineInterest(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      { lotNumber }: { lotNumber: string }
    ) {
      console.log("remove online interest", lotNumber);
    },
    async manuallySetBidderCount(
      { commit, getters, dispatch }: ActionContext<DARStore, DARStore>,
      count: BidderCount
    ) {
      console.log("set bidder count", count);
    },
    async clerkStartAuction({
      commit,
      getters,
      dispatch
    }: ActionContext<DARStore, DARStore>) {
      console.log("clerk started auction");
    }
  },
  getters: {
    lots: (state: DARStore) => state.lots,
    lot: (state: DARStore) => (number: string) =>
      state.lots.find(l => l.number === number),
    nextLot: (state: DARStore, getters: any) => getters.lot(state.nextLotId),
    currentLot: (state: DARStore, getters: any) =>
      getters.lot(state.currentLotId),
    clerkViewingLot: (state: DARStore, getters: any) =>
      getters.lot(state.clerkViewingLotId),
    previousLot: (state: DARStore, getters: any) =>
      getters.lot(state.previousLotId)
  }
};
